var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("user-header", {
    attrs: {
      infoObj: _vm.infoObj
    }
  }), _c("div", {
    staticClass: "marginT20"
  }, [_c("a-card", [_c("a-form-model", [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("部门")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.infoObj.structureName,
      callback: function ($$v) {
        _vm.$set(_vm.infoObj, "structureName", $$v);
      },
      expression: "infoObj.structureName"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-item", {
    attrs: {
      label: _vm.$t("岗位")
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      disabled: true
    },
    model: {
      value: _vm.infoObj.postName,
      callback: function ($$v) {
        _vm.$set(_vm.infoObj, "postName", $$v);
      },
      expression: "infoObj.postName"
    }
  })], 1)], 1)], 1)], 1), _c("a-form-model", {
    ref: "dataFrom",
    attrs: {
      model: _vm.dataFrom,
      rules: _vm.dataRule
    }
  }, [_c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("部门"),
      prop: "structureId"
    }
  }, [_c("a-tree-select", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      value: _vm.dataFrom.structureId,
      placeholder: _vm.$t("请选择") + _vm.$t("部门"),
      "tree-default-expand-all": "",
      "tree-data": _vm.treeData,
      replaceFields: {
        children: "children",
        title: "name",
        key: "key",
        value: "id"
      }
    },
    on: {
      change: _vm.onChange
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    staticClass: "searchBox",
    attrs: {
      label: _vm.$t("岗位"),
      prop: "postId"
    }
  }, [_c("div", {
    staticStyle: {
      display: "flex",
      "margin-top": "3px"
    }
  }, [_c("a-select", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      placeholder: _vm.$t("请选择") + _vm.$t("岗位"),
      allowClear: "",
      "show-search": "",
      "option-filter-prop": "children",
      "filter-option": _vm.filterOption
    },
    model: {
      value: _vm.dataFrom.postId,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "postId", $$v);
      },
      expression: "dataFrom.postId"
    }
  }, _vm._l(_vm.postList, function (item, index) {
    return _c("a-select-option", {
      key: index,
      attrs: {
        value: item.id
      }
    }, [_vm._v(_vm._s(item.name))]);
  }), 1), _vm.isAuth("customer.companyPostStore") ? _c("a-button", {
    attrs: {
      type: "link"
    },
    on: {
      click: _vm.addFun
    }
  }, [_vm._v(_vm._s(_vm.$t("新增")))]) : _vm._e()], 1)])], 1)], 1), _c("a-row", [_c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("生效日期"),
      prop: "effectiveAt"
    }
  }, [_c("a-date-picker", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      allowClear: "",
      format: _vm.getFormatDate(),
      valueFormat: "YYYY-MM-DD",
      "disabled-date": _vm.disabledDate
    },
    model: {
      value: _vm.dataFrom.effectiveAt,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "effectiveAt", $$v);
      },
      expression: "dataFrom.effectiveAt"
    }
  })], 1)], 1), _c("a-col", {
    attrs: {
      span: 12
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("原因"),
      prop: "reason"
    }
  }, [_c("a-input", {
    staticStyle: {
      width: "90%"
    },
    attrs: {
      placeholder: _vm.$t("请输入") + _vm.$t("原因"),
      allowClear: ""
    },
    model: {
      value: _vm.dataFrom.reason,
      callback: function ($$v) {
        _vm.$set(_vm.dataFrom, "reason", $$v);
      },
      expression: "dataFrom.reason"
    }
  })], 1)], 1)], 1)], 1), _c("div", {
    staticStyle: {
      display: "flex",
      "justify-content": "center",
      margin: "30px auto"
    }
  }, [_c("a-button", {
    attrs: {
      type: "add"
    },
    on: {
      click: _vm.onSubmit
    }
  }, [_vm._v(_vm._s(_vm.$t("确认")))])], 1)], 1)], 1), _vm.postShow ? _c("post-model", {
    ref: "postForm",
    on: {
      cancel: function ($event) {
        _vm.postShow = false;
      },
      ok: _vm.getpostResourceFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };